<div class="relative">
  <button
    type="button"
    class="comcast-select-trigger"
    [class.comcast-select-trigger--open]="isOpen()"
    [class.comcast-select-trigger--filled]="!!selectedOption"
    [class.opacity-50]="disabled"
    [attr.aria-expanded]="isOpen()"
    (click)="toggle($event)"
  >
    <span>{{ selectedLabel }}</span>
    <mat-icon class="comcast-select-icon" aria-hidden="true">
      {{ isOpen() ? 'arrow_drop_up' : 'arrow_drop_down' }}
    </mat-icon>
  </button>

  @if (isOpen()) {
    <div
      class="comcast-select-panel"
      [class.comcast-select-panel--open]="isOpen()"
      (click)="$event.stopPropagation()"
    >
      <div class="comcast-select-options">
        @for (option of optionList; track option.value) {
          <div
            class="comcast-select-option"
            [class.comcast-select-option--selected]="selectedOption === option.value"
            (click)="select(option.value, $event)"
          >
            {{ option.viewValue }}
          </div>
        }
      </div>
    </div>
  }
</div>
